export default __webpack_public_path__ + "static/media/box-header-links.36c437db.png";